import { get, post } from '@/utils/httpHelper';

module.exports = {
  async callSaveAsessment (params) {
    const url = `/esg/security/vendor/assessment/save`;
    const body = await post(url, params);
    return body.data;
  },
  async callAssessmentInfo (userType, language) {
    const url = `/esg/assessment/findAssessmentForCurrentYear/${userType}/${language}`;
    const body = await get(url);
    return body.data;
  },
  async callAssessmentList () {
    const url = `/esg/security/vendor/assessment/findActiveAssessment`;
    const body = await get(url);
    return body.data;
  },
  async callDeleteAssessment (updateAssessmentDtoStatus) {
    const url = `/esg/security/vendor/assessment/deleteAssessment`;
    const body = await post(url, updateAssessmentDtoStatus);
    return body.data;
  },
  async callConfirmAssessment (updateAssessmentDtoStatus) {
    const url = `/esg/security/vendor/assessment/confirmAssessment`;
    const body = await post(url, updateAssessmentDtoStatus);
    return body.data;
  },
  async callPreviewAssessment (previewAssessmentId) {
    const url = `/esg/security/vendor/assessment/findAssessmentById/${previewAssessmentId}`;
    const body = await get(url);
    return body.data;
  },
  async callFindAssessmentResult () {
    const url = `/esg/security/vendor/assessment/findAssessmentResult`;
    const body = await get(url);
    return body.data;
  },
  async findVendorAssessmentResultByConditions (params) {
    const url = `/esg/security/vendor/assessment/findVendorAssessmentResultByConditions`;
    const body = await get(url, params);
    return body.data;
  },
  async findAssessmentResultByConditions (params) {
    const url = `/esg/security/vendor/assessment/searchAssessmentResult`;
    const body = await get(url, params);
    return body.data;
  },
  async callResendEmail (params) {
    const url = `/esg/security/vendor/assessment/resendEmail`;
    const body = await post(url, params);
    return body.data;
  },
  async callFindUserInfo (params) {
    const url = `/esg/security/vendor/assessment/findUserInfoForResult`;
    const body = await get(url, params);
    return body.data;
  },
  async assessmentInfo (assessmentId, language) {
    const url = `/esg/assessment/findAssessment/${assessmentId}/${language}`;
    const body = await get(url);
    return body.data;
  },
  async findSearchConditions () {
    const url = `/esg/security/vendor/assessment/findSearchConditions`;
    const body = await get(url);
    return body.data;
  },
  async saveVersionNoPlusOne (answerVenderDto) {
    const url = `/esg/security/vendor/assessment/redo`;
    const body = await post(url, answerVenderDto);
    return body.data;
  },
  async  generateExcel (params) {
    const url = `/esg/security/vendor/assessment/generateReport/${params}`;
    const body = await get(url);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/answerer/assessment.repository.js